import { Navigate, Outlet } from "react-router-dom";
import { Box } from "@mui/material";

import { classNames } from "@/utils/classNames";

import { FeaturesCodes } from "@/pages/Private/pages/Users/enum/codes";

import { useIsFeatureActiveUnauthenticated } from "@/utils/useIsFeatureActiveUnauthenticated";
import { useOnboardingRedirectPath } from "@/utils/useOnboardingVariant";

import { Loader } from "@/components/Loader/Loader";

import { NotificationPanel } from "@/pages/Private/pages/Notifications/components/NotificationPanel";
import { NotificationToast } from "@/pages/Private/pages/Notifications/components/NotificationToast";

import { OnboardingTour } from "@/components/FeatureOnboarding/OnboardingTour";
import { OnboardingTourHost } from "@/pages/Private/pages/OnboardingTour/OnboardingTourHost";

import { Sidebar } from "../Sidebar/Sidebar";

export const MessagesLayout = () => {
	const initialUser = localStorage.getItem("initialUser");

	const SELF_REGISTER = useIsFeatureActiveUnauthenticated(FeaturesCodes.SELF_REGISTER);

	// Which onboarding still owes this user, derived once server-side (PREC-3719).
	const onboardingRedirect = useOnboardingRedirectPath();

	if (SELF_REGISTER === undefined) {
		return <Loader />;
	}

	if (onboardingRedirect) {
		return <Navigate to={onboardingRedirect} />;
	}

	return (
		<Box
			sx={{
				width: "100%",
				minHeight: "100vh",
			}}
		>
			<>
				<div
					className={classNames(
						"w-full flex flex-row h-[100vh]",
						initialUser ? "bg-other-org" : "bg-brand-white"
					)}
				>
					<Sidebar />
					<div className="sm:z-10 flex-grow min-w-0 h-full relative bg-white border-l border-border-light">
						<div
							// The app shell is exactly one viewport tall and every scroll happens in an
							// inner pane. Height and both overflow axes are spelled out explicitly here:
							// `overflow-auto` + `overflow-y-hidden` left it to Tailwind's property order
							// which axis won, and html/body have `overflow-y: visible`, so anything that
							// escapes this box scrolls the whole document (PREC-4114).
							className={classNames("bg-white h-screen overflow-x-auto overflow-y-hidden")}
							id="outlet-container"
							style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
						>
							<Outlet />
						</div>
					</div>
				</div>
				<NotificationPanel />
				<NotificationToast />
				<OnboardingTour />
				<OnboardingTourHost />
			</>
		</Box>
	);
};
